<template>
  <b-sidebar
    v-if="isOpenLocal"
    v-model="isOpenLocal"
    id="sidebar-right-bdr-dict"
    :title="'Распределение элемента: ' + conflictLocal.name"
    right
    backdrop
    shadow
    width="65em"
    backdrop-variant="dark"
    no-close-on-backdrop
  >
  <!-- @change="closeSidePanelCallback()" -->
    <div class="d-block"> 
      <div class="mb-4">
        <b-table-simple hover small caption-top responsive>
          <caption
            style="font-size: 18px;
            padding-bottom: 30px;
            padding-left: 10px;"
          >Выберите к какому элементу отнести строку и нажмите сохранить:
            <div><small>Вычисленное значение: <strong>{{ conflictLocal.list[0].value | toCurrency }} р.</strong></small></div>
          </caption>
          <b-thead>
            <b-tr>
              <b-th>№ в БДР</b-th>
              <b-th>Имя в сводной БДР</b-th>
              <b-th v-if="solveWithoutPredictions">Имя в словаре 1С</b-th>
              <b-th>Признак</b-th>
              <b-th>Действие</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr
              v-for="(item, index) in conflictLocal.list"
              :key="index"
            >
              <b-td class="text-center">
                {{ item.bdr }}
              </b-td>
              <b-td>
                {{ item.name }}
              </b-td>
              <b-td v-if="solveWithoutPredictions">
                {{ item.onec_name }}
              </b-td>
              <b-td>
                {{ item.priznak_line }}
              </b-td>
              <b-td class="text-center">
                <b-button
                  @click="checkSolve(index)"
                  size="sm"
                  :variant="item.checked ? 'success': 'outline-secondary'"
                  class="ml-2"
                  style="width: 37px; height: 35px;"
                  :disabled="loading"
                >
                  <b-icon icon="check-lg" scale="1.5"></b-icon>
                </b-button>                                
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </div> 

      <div class="d-flex mt-2 mb-2">
        <b-button
            size="md"
            class="ml-auto btn btn-secondary"
            @click="closeSidebar()"
            :disabled="loading"
        >
            Отмена
        </b-button>
        <b-button
            size="md"
            class="ml-2 btn btn-primary"
            @click="saveElement()"
            :disabled="checkedIndex == -1"
        >
            Сохранить <b-icon v-if="loading" icon="arrow-repeat" scale="1.2" aria-label="Reload" :animation="loading ? 'spin' : ''"></b-icon>
        </b-button>
      </div>
    </div>     
  </b-sidebar>   
</template>

<script>
import { API_BDR_SAVE_ONE_ELEMENT } from '@/constants';

export default {
  name: 'BdrSolveConflicts',
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    solveWithoutPredictions: {
      type: Boolean,
      default: false
    },
    conflict: {
      type: Object,
      default: () => ({
        list: [],
        name: '',
        file_name: '',
        r_index: -1
      }),
    },
  },
  components: {
  },
  // watch: {
  //   conflict: {
  //       deep: true,
  //       handler(conflict) {
  //         console.log("IN!", conflict)
  //         console.log("isOpenLocal", this.isOpenLocal);
  //       },
  //   }, 
  // },  
  computed: {
    isOpenLocal: {
      get: function() {
        return this.isOpen
      },
      set: function(value) {
        this.$emit('update:isOpen', value)
      }
    },
    conflictLocal: {
      get: function() {
        return this.conflict
      },
      set: function(value) {
        // this.$emit('update:conflict', value)
      }
    },     
  },  
  data() {
    return {
      loading: false,
      checkedIndex: -1
    }
  },
  mounted() {
  },
  methods: {
    closeSidebar() {
      this.isOpenLocal = false;
    },
    checkSolve(index) {
      if (this.checkedIndex != index) {
        this.checkedIndex = index;
      } else {
        this.checkedIndex = -1;
      }
      
      this.conflictLocal.list.forEach((element, e_key) => {
        if (e_key === this.checkedIndex) {
          element.checked = true;
        } else {
          element.checked = false;
        }
      });
    },
    saveElement() {
      this.loading = true;
        axios.post(`${API_BDR_SAVE_ONE_ELEMENT}`, { 'addBdr': this.conflictLocal.list[this.checkedIndex] })
        .then(() => {
          this.$emit('updateOtchet', this.conflictLocal.file_name, this.conflictLocal.r_index);
          this.loading = false;
          this.closeSidebar();
        });
    }
  },  
}
</script>
